<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17.098"
    height="19.859"
    viewBox="0 0 17.098 19.859"
  >
    <g transform="translate(-948.356 -526.976)">
      <path
        d="M962.01,548.474l-4.849-2.719-4.849,2.707,1.051-5.479-4.183-3.827,5.518-.635,2.467-4.891,2.43,4.892,5.418.636-4.168,3.822Zm-11.1-8.758,3.275,3-.826,4.3,3.8-2.125L960.928,547l-.91-4.288,3.273-3-4.188-.491-1.942-3.909-1.972,3.909Z"
        transform="translate(-0.203 -1.639)"
      />
      <rect
        width="0.754"
        height="3.67"
        transform="matrix(0.807, -0.591, 0.591, 0.807, 948.356, 530.189)"
      />
      <rect
        width="3.67"
        height="0.754"
        transform="translate(962.677 532.704) rotate(-53.779)"
      />
      <rect
        width="0.754"
        height="3.844"
        transform="translate(956.584 526.976)"
      />
    </g>
  </svg>
</template>
